module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noDataToShow":"No data to show."},"ru":{"noDataToShow":"Нет данных."},"ua":{"noDataToShow":"Дані відсутні."}}')
  delete Component.options._Ctor
}
